import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

/**
 * Small "vs last period" indicator shown next to a KPI value.
 * Renders nothing when there's no comparable previous period (e.g. "All Time" filter).
 */
export const KpiTrendBadge = ({ current, previous, testId }) => {
  if (previous == null || current == null) return null;

  if (previous === 0) {
    if (!current) return null;
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-blue-600" data-testid={testId}>
        <TrendingUp className="w-3 h-3" />
        New
      </span>
    );
  }

  const pct = Math.round(((current - previous) / previous) * 100);
  if (pct === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground" data-testid={testId}>
        <Minus className="w-3 h-3" />
        Flat vs last period
      </span>
    );
  }

  const isUp = pct > 0;
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium ${isUp ? 'text-green-600' : 'text-red-600'}`}
      data-testid={testId}
    >
      {isUp ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
      {Math.abs(pct)}% vs last period
    </span>
  );
};

export default KpiTrendBadge;
